import React from "react";
import { useBreakpoints } from "~hooks";
import { AtfMobile, AtfDesktop } from "~components";

const HomepageAtf = ({ data }) => {
  const bp = useBreakpoints();

  const getInitialSlideIndex = () => {
    const { slides } = data;
    const date = new Date();
    const time = date.getHours(); // 0-23
    const day = date.getDay(); // 0-6, Sun-Sat

    const dateOptions = [
      {
        string: `10pm - 3am (any day)`,
        times: [22, 23, 0, 1, 2],
        days: [0, 1, 2, 3, 4, 5, 6]
      },
      {
        string: `8am - 1pm (Sunday)`,
        times: [8, 9, 10, 11, 12],
        days: [0]
      },
      {
        string: `8am - 5pm (Mon-Fri)`,
        times: [8, 9, 10, 11, 12, 13, 14, 15, 16],
        days: [1, 2, 3, 4, 5]
      }
    ];

    for (let i = 0; i < dateOptions.length; i++) {
      const option = dateOptions[i];
      if (option.times.includes(time) && option.days.includes(day)) {
        const matchingSlide = slides.find(
          (slide) => slide.whenToDisplay === option.string
        );
        return slides.indexOf(matchingSlide);
      }
    }

    return Math.floor(Math.random() * slides.length);
  };

  return (
    <article>
      {bp.largeTablet ? (
        <AtfDesktop data={data} initialSlideIndex={getInitialSlideIndex()} />
      ) : (
        <AtfMobile data={data} initialSlideIndex={getInitialSlideIndex()} />
      )}
    </article>
  );
};

export default HomepageAtf;
